import React from 'react';
import TopSlider from "../components/homePage/topSlider/TopSlider";
import SpecialOffer from "../components/homePage/specialOffer/SpecialOffer";
import NewProducts from "../components/homePage/newProducts/NewProducts";
import Phone from "../components/homePage/phone/Phone";
import Brands from "../components/homePage/brands/Brands";
import RecentVisits from "../components/homePage/recentVisits/RecentVisits";
import EndBanner from "../components/homePage/banners/endBanner/EndBanner";
import SpecialPackages from "../components/homePage/specialPackages/SpecialPackages";
import LatestNews from "../components/homePage/latestNews/LatestNews";
import NumberedProducts from "../components/homePage/numberedProducts/NumberedProducts";
import ButtonLinkSayman from "../components/homePage/buttonLinkSayman/ButtonLinkSayman";
import TopProductSlider from "../components/homePage/topProductSlider/TopProductSlider";
import Banners from "../components/homePage/banners/middleBanners/Banners";


const HomePage = () => {
    return (
        <main id="main">
            <ButtonLinkSayman/>
            <TopSlider/>
            <TopProductSlider/>
            <SpecialOffer/>
            <NewProducts/>
            <Phone/>
            <Banners/>
            <NumberedProducts/>
            <Brands/>
            <RecentVisits/>
            <EndBanner/>
            <SpecialPackages/>
            <LatestNews/>
        </main>
    );
};

export default HomePage;
